import i18n from './i18n'

export default {
  required: value => !!value || i18n.blank
}
